import { render, staticRenderFns } from "./course-guides-add-group-modal.vue?vue&type=template&id=59a3339c"
import script from "./course-guides-add-group-modal.vue?vue&type=script&lang=js"
export * from "./course-guides-add-group-modal.vue?vue&type=script&lang=js"
import style0 from "./course-guides-add-group-modal.vue?vue&type=style&index=0&id=59a3339c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports